import { LOAD_ABOUT_DATA_SUCCESS, LOAD_HOME_DATA_SUCCESS } from './actions';
import { createSelector } from 'reselect';
import { GlobalState } from '../rootReducer';

// reducer
const DEFAULT_STATE = {
    categories: [],
    featuredCategoriesTitle: '',
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    let categories;
    let featuredCategoriesTitle;

    switch (action.type) {
        case LOAD_ABOUT_DATA_SUCCESS:
        case LOAD_HOME_DATA_SUCCESS:
            // categories
            if (action.payload.categories) {
                categories = action.payload.categories.map((x) => {
                    // in the case that we're passed the full url, remove the part we dont need.
                    let link = x.link || '';
                    link = link
                        .replace('https://www.liveauctioneers.com', '')
                        .replace('http://www.liveauctioneers.com', '');
                    // add in the label until the api returns it
                    return {
                        label: x.title,
                        ...x,
                        link,
                    };
                });
            } else {
                categories = [];
            }

            if (action.payload.featuredCategoriesTitle) {
                featuredCategoriesTitle = action.payload.featuredCategoriesTitle;
            }

            return {
                ...state,
                categories,
                featuredCategoriesTitle,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.featuredCategories;

export const featuredCategoriesSelector = createSelector(stateSelector, (state) => state.categories);

export const featuredCategoriesTitleSelector = createSelector(stateSelector, (state) => state.featuredCategoriesTitle);
